/**
 * @typedef {ReturnType<typeof import('widgets/forms/AjaxForm').default>} AjaxForm
 */

/**
 * @description WhereToBuyForm implementation
 * @param {AjaxForm} AjaxForm Base widget for extending
 * @returns {typeof WhereToBuyForm} WhereToBuy Form class
 */
export default function (AjaxForm) {
    /**
     * @class WhereToBuyForm
     * @augments AjaxForm
     */
    return class WhereToBuyForm extends AjaxForm {
        init() {
            super.init();

            // due to we have Widgets logic crossed with BrandSDK functionallity,
            // submit button has to be disabled until ejgWTB_callback will be received
            // next code just modifying callback function with widget specific logic
            const oldCallback = global.ejgWTB_callback;
            global.ejgWTB_callback = () => {
                oldCallback();

                this.getById('submit', submitButton => {
                    submitButton.enable();
                });
            };
            
            //Sometimes ejgWTB_callback is received before this file loads
            //Which is causing the submit button to be disabled even after the page loads
            //Hence placing the code outside to enable submit button to work every time
            this.getById('submit', submitButton => {
                submitButton.enable();
            });
        }
    };
}
